import { mesaColorNames, spacing, typography } from '@/src/common/theme'
import { memo } from 'react'
import { StyleSheet, Text, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    width: '100%',
    paddingVertical: spacing.base,
  },
  label: {
    color: mesaColorNames['semantic/fg/subtle #898D8F'],
    ...typography['heading/heading6'],
  },
})

export type ActivityFeedSectionHeaderProps = {
  title: string
}

const ActivityFeedSectionHeader = ({ title }: ActivityFeedSectionHeaderProps) => (
  <View style={styles.container}>
    <Text style={styles.label}>{title}</Text>
  </View>
)

export const RewardsComponentsActivityFeedSectionHeader = memo(ActivityFeedSectionHeader)
